export default {"src":"/_next/static/media/Queen Bedframe.e2b89934.svg","height":60,"width":108};